import TrialExpired from "./TrialExpired";


const TrialExpiredContainer = () => {
  return <TrialExpired />;
};

export default TrialExpiredContainer;